import { Currency } from "@/types";
import pkg from "./package.json";

export const VERSION = pkg.version;

export const APP_ENV = process.env.VUE_APP_APP_ENV;

export const NODE_ENV = process.env.NODE_ENV;

export const APP_TOKEN = process.env.VUE_APP_TOKEN;

export const IS_PRODUCT = APP_ENV === "production";

export const CONFIGS = IS_PRODUCT
  ? {
      MIXIN_CLIENT_ID: "f49c073a-f92c-4268-ab81-25805d8a108f",
      FOX_CLIENT_ID: "",
      OTC_URL: "http://user.zotc.vip/#/",
      OTC_KYC_URL: "https://user.zotc.vip/#/my/kyc_result",
      MIXIN_OAUTH_HOST: "https://mixin-oauth.fox.one",
      FOXONE_OAUTH_HOST: "https://foauth.fox.one",
      FUSION_API_HOST: "https://fusion-api.fox.one",
      WEB_HOST: "https://fusion.fox.one",
      HELP_URL: "https://zh.cms.fox.one/2021/06/02/elitewallet/",
      CHAT_URL: "https://mixin.one/codes/36c5ad31-b7e7-432b-9fc2-1c29061b25dd",
      GA: "UA-112996081-8",
      BUGSNAG: "5e3ac10d177242aaac01b4126d77300c",
      SWAP_URL: "https://app.4swap.org/#/"
    }
  : {
      MIXIN_CLIENT_ID: "4ba26985-92f4-4694-b47e-c349f526d685",
      FOX_CLIENT_ID: "",
      OTC_URL: "http://user-dev.zotc.vip/#/",
      OTC_KYC_URL: "http://user-dev.zotc.vip/#/my/kyc_result",
      MIXIN_OAUTH_HOST: "https://mixin-oauth.fox.one",
      FOXONE_OAUTH_HOST: "https://foauth.fox.one",
      FUSION_API_HOST: "https://fusion-api.fox.one",
      WEB_HOST: "https://fusion-test.fox.one",
      HELP_URL: "https://zh.cms.fox.one/2021/06/02/elitewallet/",
      CHAT_URL: "https://mixin.one/codes/36c5ad31-b7e7-432b-9fc2-1c29061b25dd",
      GA: "",
      BUGSNAG: "",
      SWAP_URL: "https://app.4swap.org/#/"
    };

export const MIXIN_DEPOSIT_HELP = {
  en:
    "https://mixinmessenger.zendesk.com/hc/en-us/articles/360018789931-How-to-deposit-on-Mixin-Messenger-",
  zh:
    "https://mixinmessenger.zendesk.com/hc/zh-cn/articles/360018789931-%E5%A6%82%E4%BD%95%E5%85%85%E5%80%BC-"
};

export const DOWNLOAD_LINK = {
  en: "https://f1-install-guide.fox.one/en.html",
  zh: "https://f1-install-guide.fox.one/zh.html"
};

export const CURRENCY = {
  cny: { unit: "CNY", symbol: "¥" },
  usd: { unit: "USD", symbol: "$" },
  jpy: { unit: "JPY", symbol: "¥" }
};

export const INTL = {
  zh: {
    currency: "cny",
    locale: "zh",
    symbol: "¥"
  },
  en: {
    currency: "usd",
    locale: "en",
    symbol: "¥"
  },
  ja: {
    currency: "jpy",
    locale: "ja",
    symbol: "¥"
  }
};

export const FC = {
  symbol: "FC",
  id: "fc"
};

export const CURRENCY_MAP = {
  cny: Currency.CNY,
  usd: Currency.USD,
  "¥": Currency.CNY,
  $: Currency.USD
};

export const ROOT_EVENTS = {
  PIN_ENTER: "pin_enter",
  ASSETS_FORBIDDEN: "assets_forbidden",
  ASSETS_SELECT: "assets_select"
};

export const MIXIN_SCHEME = {
  CODES: "mixin://codes",
  PAY: "mixin://pay",
  USERS: "mixin://users",
  TRANSFER: "mixin://transfer",
  DEVICE: "mixin://device/auth",
  SEND: "mixin://send",
  ADDRESS: "mixin://address",
  WITHDRAWAL: "mixin://withdrawal",
  APPS: "mixin://apps",
  SNAPSHOTS: "mixin://snapshots",

  HTTPS_CODES: "https://mixin.one/codes",
  HTTPS_PAY: "https://mixin.one/pay",
  HTTPS_USERS: "https://mixin.one/users",
  HTTPS_TRANSFER: "https://mixin.one/transfer",
  HTTPS_ADDRESS: "https://mixin.one/address",
  HTTPS_WITHDRAWAL: "https://mixin.one/withdrawal",
  HTTPS_APPS: "https://mixin.one/apps"
};
